import React from 'react';
import MonthRecordingsUI from './MonthRecordingsUI';

const FOLDERS = ['Past Paper Class', 'QQ Class', 'Write to Bright Class', 'Paper Shaper'];

const October = () => <MonthRecordingsUI month="October" gradeFilter="Grade 10 & 11" folders={FOLDERS} />;

export default October;
